module.exports = __webpack_public_path__ + "static/media/vision-icon-monitor.bbf3913b.png";